module.exports = __webpack_public_path__ + "static/media/19d4de8e-758a-468a-a59c-b8ba191520e5.47421015.JPG";